let RMOrder = function (app) {
    this.app = app;
    this.container = null;
    this.itemsCount = 0;
    this.totalSaleSum = 0;

    this.clearTxt = '<div style="text-align: center">ПУСТО</div>';
    this.id = Math.floor(Math.random() * (9999 - 1000)) + 1000;
    this.fabrics = app.params.init_data.fabrics;
    this.data = null;

    this.totalCount = 0;
    this.totalPrice = 0;
    this.totalSale = 0;
    this.totalSale2 = 0;
    this.totalTotal = 0;

    this.totalPriceCornice = 0;
    this.totalCorniceSale = 0;
    this.totalCornice = 0;

    this.totalPriceVForm = 0;
    this.totalVFormSale = 0;
    this.totalVForm = 0;

    this.totalSize = '';

    this.items = [];
    this.itemsCornice = [];

    this.data = null;
    this.materials = null;

    this.H = this.app.params.H;

    this.contentBlock = null;
    this.buttonsBlock = null;
    this.discounts = null;
    this.discounts_pf = null;
    this.isPF = false;

    this.prevOrders = [];
    this.prevOrdersCount = 0;
    this.types = [];

    this.matAmounts = {};

    this.mode = 2;

    if (this.app.orderBlock_content) this.contentBlock = this.app.orderBlock_content;
    if (this.app.orderBlock_buttons) this.buttonsBlock = this.app.orderBlock_buttons;

    if (this.app.orderBlock_content) this.proccessContentBlock = this.app.contentBlock;

    this.init = function () {
        if (!this.items) this.items = [];
        if (!this.itemsCornice) this.itemsCornice = [];
        this.itemsCount = this.items.length + this.itemsCornice.length;
        this.data = this.app.params.init_data.items;
        this.materials = this.app.params.init_data.materials;
        this.discounts = this.app.discounts;
        this.discounts_pf = this.app.discounts_pf;
        this.isPF = this.app.isPF;
        this.prevOrders = this.app.prevOrders;
        this.prevOrdersCount = this.app.prevOrdersCount;
        this.mode = this.app.mode;

        this.reCalc();
    };

    this.getMatAmount = function (template) {
        let matAmount = 0;
        if (template) {
            if (template.gab_height && template.gab_width && template.type && template.amount) {
                let w = parseFloat(template.gab_width) / 1000;
                let h = parseFloat(template.gab_height) / 1000;
                let a = parseFloat(template.amount);
                if (isNaN(w)) w = 0;
                if (isNaN(h)) h = 0;
                if (isNaN(a)) a = 0;
                switch (template.type) {
                    case 'rolo':
                        matAmount = w * h * a;
                        break;
                    case 'zebra':
                        matAmount = w * h * a * 2;
                        break;
                    case 'hblinds':
                    case 'ks25':
                        matAmount = (w * h * a) * 46;
                        break;
                    case 'plisse':
                        break;
                    case 'vblinds':
                        break;
                }
            }
        }
        return matAmount;
    };

    this.calcMatAmounts = function () {
        this.matAmounts = {};

        for (let key = this.items.length - 1; key >= 0; key--) {
            if (this.items[key]) {
                if (!this.items[key].matAmount) {
                    this.items[key].matAmount = this.getMatAmount(this.items[key]);
                } else {
                    this.items[key].matAmount = parseFloat(this.items[key].matAmount);
                    if (isNaN(this.items[key].matAmount)) this.items[key].matAmount = 0;
                }
                if (!this.matAmounts[this.items[key].material]) this.matAmounts[this.items[key].material] = 0;
                this.matAmounts[this.items[key].material] += this.items[key].matAmount;
            }
        }

        return this.matAmounts;
    };

    this.prepareItems = function () {
        let self = this;
        if (!this.items) this.items = [];
        let ret = [];

        for (let key in this.items) {
            if (Object.prototype.hasOwnProperty.call(this.items, key) && this.items[key] && this.items[key].amount > 0) {
                this.items[key].mode = self.mode;

                // if (this.items[key].mid == 6 || this.items[key].mid == 13 || this.items[key].mid == 141) {
                //     if (this.items[key].countToOrder == 0 && this.items[key].countFromStorage > 0) {
                //         this.items[key].mode = 2
                //     } else if (this.items[key].countToOrder > 0 && this.items[key].countFromStorage > 0) {
                //         let priceForOne = this.items[key].price / this.items[key].amount
                //         let salePriceForOne = this.items[key].salePrice / this.items[key].amount
                //         let matAmountForOne = this.items[key].matAmount / this.items[key].amount
                //
                //         this.items[key].amount = this.items[key].countToOrder
                //         this.items[key].price = this.items[key].amount * priceForOne
                //         this.items[key].salePrice = this.items[key].amount * salePriceForOne
                //         this.items[key].matAmount = this.items[key].amount * matAmountForOne
                //
                //         this.items.push(JSON.parse(JSON.stringify(this.items[key])))
                //         this.items[this.items.length - 1].amount = this.items[key].countFromStorage
                //         this.items[this.items.length - 1].price = this.items[key].countFromStorage * priceForOne
                //         this.items[this.items.length - 1].salePrice = this.items[key].countFromStorage * salePriceForOne
                //         this.items[this.items.length - 1].matAmount = this.items[key].countFromStorage * matAmountForOne
                //         this.items[this.items.length - 1].mode = 2
                //     }
                // }
            }
        }

        for (let key in this.items) {
            if (this.items[key].mid > 400) {
                if (this.items[key].mid == 405) {
                    this.items[key].gab_width = parseInt(this.items[key].gab_width) + 37;
                } else if (this.items[key].mid == 406) {
                    this.items[key].gab_width = parseInt(this.items[key].gab_width) + 40;
                }

                this.items[key].mid = this.items[key].mid - 400;
            }

            if (Object.prototype.hasOwnProperty.call(this.items, key) && this.items[key] && this.items[key].amount > 0) {
                if (this.data[this.items[key].mid]) {
                    let item = this.items[key];
                    let tpl = this.data[this.items[key].mid];

                    item.price = Math.round(item.price * 100) / 100;

                    if (item.sale == 0 || self.mode == 2) {
                        item.sale = this.totalSale;
                    }

                    //Акция, +6% скидки на ГЖ
                    // if (item.mid != 14 && item.sale > 0) {
                    //     item.sale = item.sale + 7;
                    // }

                    item.salePrice = item.price - (item.sale / 100 * item.price);

                    item.salePrice = Math.round(item.salePrice * 100) / 100;

                    if (tpl.crutch) {
                        for (let k in tpl.crutch) {
                            if (Object.prototype.hasOwnProperty.call(tpl.crutch, k)) {
                                item[k] = tpl.crutch[k];
                            }
                        }
                    }

                    ret.push(item);
                } else if (this.items[key].mid > 100) {
                    let item = this.items[key];

                    item.price = Math.round(item.price * 100) / 100;
                    // if (item.mid < 100 || item.mid > 200) {
                    if (item.sale == 0 || self.mode == 2) {
                        item.sale = this.totalSale;
                    }
                    // } else {
                    //     item.sale = 35;
                        // item.sale = 0;
                    // }
                    item.salePrice = item.price - (item.sale / 100 * item.price);
                    item.salePrice = Math.round(item.salePrice * 100) / 100;

                    ret.push(item);
                }

                if (this.items[key].mid == 202) {
                    this.items[key].height = this.items[key].height * 10; //Фикс для отправки в БД
                }
            }
        }

        this.itemsCount = this.items.length;

        return ret;
    };

    this.createProccessItemModel = function (num, key, item) {
        let name = '';
        let material = '';
        let img = '';
        let paramsHTML = '';
        let data = null;
        if (this.data && this.data[item.mid]) data = this.data[item.mid];
        if (data && data.name) name = data.nameRu + ' ' + data.name;
        if (this.materials && this.materials[item.material]) {
            material = this.materials[item.material].name;
            img = this.materials[item.material].img;
        }
        if (data && data.params) {
            for (let key in data.params) {
                if (Object.prototype.hasOwnProperty.call(data.params, key)) {
                    if (item[key]) {
                        let param = data.params[key];
                        if (param.options && param.options[key + '_' + item[key]]) {
                            let option = param.options[key + '_' + item[key]];
                            paramsHTML += '<b>' + param.name + ': </b>' + option.name + '<br />';
                        }
                    }
                }
            }
        }
        return {
            module: 'basket',
            key: key,
            num: num,
            name: name,
            material: material,
            img: img,
            width: item.gab_width / 10,
            height: item.gab_height / 10,
            amount: item.amount,
            price: this.app.number_format(item.price, 2, '.', ' '),
            params: paramsHTML,
            deleteFunction: 'deleteOrderItem',
        }
    };

    this.proccess = function () {
        if (this.itemsCount === 0) {
            if (this.app && this.app.clear) this.app.clear();
        }
    };

    this.store = function (id, template) {
        this.items[this.items.length] = template;
        this.itemsCount = this.items.length;
        this.reCalc();
    };

    this.remove = function (id) {
        this.items.splice(id, 1);
        this.itemsCount = this.items.length;

        this.H.set('rm_items', this.items);
        this.reCalc();
    };

    this.clear = function () {
        this.items = [];
        this.itemsCount = this.items.length;

        this.H.set('rm_items', this.items);
        this.reCalc();
    };

    this.reCalc = function () {
        this.totalCount = 0; //Общее число товаров

        this.totalPriceRM = 0;
        this.totalPrice = 0; //Общая сумма без скидки (без учета карнизов?)
        this.totalSale = 0; //% Общая скидка (по дисконту), без учета акций и проч.
        this.totalSale2 = 0; //% Средняя скидка, среднее арифметическое скидок на товары (по дисконту и акциям)
        this.totalSaleSum = 0; //Общая скидка в рублях
        this.totalTotal = 0; //Общая сумма со скидкой

        this.totalCountCornice = 0; //Общее число карнизов
        this.totalPriceCornice = 0;
        this.totalCorniceSale = 0; //Скидка на карнизы в рублях

        this.totalPriceVForm = 0;
        this.totalVFormSale = 0;
        this.totalVForm = 0;

        this.totalSize = '';

        this.types = [];
        for (let k in this.app.prevOrdersTypes) {
            if (Object.prototype.hasOwnProperty.call(this.app.prevOrdersTypes, k)) {
                this.types.push(this.app.prevOrdersTypes[k]);
            }
        }

        this.app.mid = 0;

        let x = 0, y = 0, z = 0;

        for (let key in this.items) {
            if (Object.prototype.hasOwnProperty.call(this.items, key) && this.items[key]) {
                if (this.items[key].discount) {
                    let data = this.app.params.init_data.items[this.items[key].mid];
                    if (data.discount) {
                        this.app.mid = this.items[key].mid;
                    } else {
                        this.remove(key);
                    }
                }

                this.totalPrice += this.items[key].price;

                if (this.items[key].mid > 100 && this.items[key].mid < 110) {
                    this.totalPriceCornice += this.items[key].price;
                    this.totalCountCornice += this.items[key].amount;
                } else if (this.items[key].mid > 200) {
                    this.totalPriceVForm += this.items[key].price;
                    this.totalCountVForm += this.items[key].amount;
                } else {
                    this.totalPriceRM += this.items[key].price;
                }

                this.totalCount += parseInt(this.items[key].amount);
                this.types.push(this.items[key].type + '_' + this.items[key].subtype);

                if (this.items[key].packSize) {
                    let size = this.items[key].packSize.split(' х ')
                    // console.log(size)

                    let boxes = this.items[key].amount / this.items[key].amountInPack

                    // console.log(this.items[key].amount, this.items[key].amountInPack)
                    // console.log(boxes)

                    if (size[1] && size[2]) {
                        x += size[0] * boxes;
                        y += size[1] * boxes;
                        z += size[2] * boxes;
                    }
                }
            }
        }

        this.totalSize = x + ' x ' + y + ' x ' + z;

        let fullAmount = this.totalCount + this.prevOrdersCount;

        //Определяем глобальную скидку
        this.totalSale = 0;
        if (this.app.mid > 0) {
            //
            //
        } else {
            if (this.discounts) {
                let discountsActual = this.discounts;
                if (this.isPF && this.discounts_pf && this.mode == 2) {
                    discountsActual = this.discounts_pf;
                }

                let prev_count = 0;
                for (let count in discountsActual) {
                    if (fullAmount >= prev_count && fullAmount < count) {
                        if (Object.prototype.hasOwnProperty.call(discountsActual, count)) {
                            this.totalSale = discountsActual[prev_count];
                        }
                        break;
                    } else if (fullAmount >= count) {
                        if (Object.prototype.hasOwnProperty.call(discountsActual, count)) {
                            this.totalSale = discountsActual[count];
                        }
                    }
                    prev_count = count;
                }

                this.types = window.array_unique(this.types);
            }
        }

        //Применяем скидки
        let salesSum = 0;
            // itemsRMSaleSum = 0, //Считаем рулонку, ГЖ и ВЖ отдельно, на них могут быть акции
            // itemsVFormSaleSum = 0;
        for (let key in this.items) {
            if (Object.prototype.hasOwnProperty.call(this.items, key) && this.items[key]) {
                // if (this.items[key].sale == 0 || this.mode == 2) {
                if (this.items[key].sale == 0) {
                    salesSum = salesSum - - this.totalSale;
                    this.totalTotal += this.items[key].price - (this.totalSale / 100 * this.items[key].price);
                // } else if (this.mode == 1) {
                } else {
                    salesSum = salesSum - - this.items[key].sale;
                    this.totalTotal += this.items[key].price - (this.items[key].sale / 100 * this.items[key].price);
                }
            }
        }

        this.totalSale2 = salesSum / this.items.length;

        // console.log('t1', this.totalTotal)
        // this.totalTotal = this.totalPrice - (this.totalSale / 100 * this.totalPriceRM) - (this.totalSale / 100 * this.totalPriceCornice) - (this.totalSale / 100 * this.totalPriceVForm);
        // console.log('t2', this.totalTotal)

        this.totalCornice = this.totalPriceCornice - (this.totalSale / 100 * this.totalPriceCornice);
        this.totalCorniceSale = this.totalSale / 100 * this.totalPriceCornice;

        this.totalVForm = this.totalPriceVForm - (this.totalSale / 100 * this.totalPriceVForm)
        this.totalVFormSale = this.totalPriceVForm - this.totalVForm

        this.totalSaleSum = this.totalPrice - this.totalTotal;

        this.calcMatAmounts();
    };

    this.destroy = function () {
    };

    this.init();
};

export default RMOrder;
